const CONFIG = {
    priorityLevelBoundaryIndex: 4,
};
export default CONFIG;
//# sourceMappingURL=constants.js.map